import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireAuth = () => {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  // TODO: 테스트용 - 인증 체크 우회
  return <Outlet />;

  // if (!isLoggedIn) {
  //   return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  // }
  // return <Outlet />;
};

export default RequireAuth;
